import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const getConfig = id => ({
  type: types.GET_CONFIG,
  id,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
